module.exports = __webpack_public_path__ + "img/obs_water_flood_down.1318338f.svg";